export default "__VITE_ASSET__BaFd74fi__"